import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetBankQuery } from '../../../api/queries/getBank';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import BankDetailsInnerPage from './BankDetailsInnerPage';

const BankDetailsPage = () => {
    const { bankId } = useParams<{ bankId: string }>();

    const { data, loading } = useGetBankQuery({
        fetchPolicy: 'network-only',
        variables: { id: bankId },
    });

    const bank = data?.bank;

    if (!bank && loading) {
        return <LoadingElement />;
    }

    if (!bank) {
        return <NotFoundResult />;
    }

    return <BankDetailsInnerPage key={bank.id} bank={bank} />;
};

export default BankDetailsPage;
